module.exports = __webpack_public_path__ + "static/02@2x-144889a39895efd5fbf18ed47edd0b61.png";